class VariantSelects extends HTMLElement {
  constructor() {
      super();
      this.splide = new Splide('.splide', {
          perPage: 1,
          gap: '12px',
          padding: '12px',
          arrows: false,
          fixedWidth: '93%',
          pagination: false,
      });
      this.splide.mount();
      this.onVariantChange();
      this.addEventListener('change', this.onVariantUpdate);
  }

  setLoading(isLoading = true) {
      const wrapper = document.getElementById('product-details-wrapper');
      const labels = wrapper.querySelectorAll('label');
      const button = wrapper.querySelectorAll('[name="add"]');
      const elements = [...labels, ...button];
      elements.forEach(el => el.disabled = isLoading);
  }

  async onVariantUpdate() {
    //console.log("async onVariantUpdate");
      this.setLoading(true);

      const responseText = await this.onVariantChange();
      this.renderProductImages(this.currentVariant.id, responseText);
      //this.renderBillboard(this.currentVariant.id);

      this.setLoading(false);

  }

  async onVariantChange() {
    //console.log("async onVariantChange");
      this.updateOptions();
      this.updateCurrentVariant();
      const responseText = await this.fetchProductInfo(this.currentVariant.id)

      this.toggleAddButton(true, '', false);
      this.removeErrorMessage();

      if (!this.currentVariant) {
        //console.log("no current variant");
          this.toggleAddButton(true, '', true);
          this.setUnavailable();
      } else {
        //console.log("yes current variant");
          var cv = this.currentVariant;
          //console.log(cv);
          var priceRaw = this.currentVariant.price;
          var priceCompareRaw = this.currentVariant.compare_at_price;
          this.renderProductInfo(shopifyMoneyFormat(this.currentVariant.price), responseText,shopifyMoneyFormat(this.currentVariant.compare_at_price),priceRaw,priceCompareRaw);
          this.renderStock(this.currentVariant.id, responseText);
          this.renderCartStock(this.currentVariant.id, responseText);
          this.updateURL();
          this.updateVariantInput();
      }

      return responseText;
  }

  updateOptions() {
      this.options = Array.from(this.querySelectorAll('select'), (select) => select.value);
  }

  async fetchProductInfo() {
      const fetchUrl = `${this.dataset.url}?variant=${this.currentVariant.id}&section_id=${this.dataset.section}`;
      return await fetch(fetchUrl)
          .then((response) => response.text())
          .then((responseText) => responseText);
  }

  updateCurrentVariant() {
      this.currentVariant = this.getVariantData().find((variant) => {
          return !variant.options.map((option, index) => {
              return this.options[index] === option;
          }).includes(false);
      });
  }

  toggleAddButton(disable = false, text, modifyClass = true, endOfLifeDisable = false) {
    console.log("hello from toggleAddButton where disable is ", disable, " and text is ", text, " and modifyClass is ", modifyClass, " and endOfLifeDisable is ", endOfLifeDisable);
    const productForm = document.getElementById(`product-form-${this.dataset.section}`);
    const productFormWrapper = document.getElementById('product-details-wrapper');
      if (!productForm) return;
      if (endOfLifeDisable) {
        productFormWrapper.classList.add('end-of-life-variant');
      } else {
        productFormWrapper.classList.remove('end-of-life-variant');
      }
      const addButton = productForm.querySelector('[name="add"]');
      const addButtonDisplayed = productForm.querySelector('#addToCartButton');
      const addButtonText = productForm.querySelector('.button-content');

      if (!addButton) return;

      if (disable) {
        //console.log("disable");
        if (text) addButtonText.textContent = text;
        if (endOfLifeDisable) {
          if (addButton) addButton.disabled = true; // Assuming this is the actual submit button which might not always be visible
          if (addButtonDisplayed) addButtonDisplayed.disabled = true;
        } else {
          if (addButtonDisplayed) addButtonDisplayed.disabled = false;
          addButton.removeAttribute('disabled');
        }
      } else {
        //console.log("don't disable");
        if (addButtonDisplayed) addButtonDisplayed.disabled = false;
          addButton.removeAttribute('disabled');
          addButtonText.textContent = 'Add To Cart';
      }

      if (!modifyClass) return;
  }

  removeErrorMessage() {
      const section = this.closest('section');
      if (!section) return;
      const productForm = section.querySelector('product-form');
      if (productForm) productForm.handleErrorMessage();
  }

  updateURL() {
    //alert("updating url from variant-radio.js");
      if (!this.currentVariant || this.dataset.updateUrl === 'false') return;
      window.history.replaceState({}, '', `${this.dataset.url}?variant=${this.currentVariant.id}`);
  }

  updateVariantInput() {
      const productForms = document.querySelectorAll(`#product-form-${this.dataset.section}, #product-form-installment`);
      productForms.forEach((productForm) => {
          const input = productForm.querySelector('input[name="id"]');
          input.value = this.currentVariant.id;
          input.dispatchEvent(new Event('change', {bubbles: true}));
      });
  }

  renderProductInfo(currentPrice, responseText,comparePrice,priceRaw,comparePriceRaw) {
    //console.log("renderProductInfo");
      const id = `price-${this.dataset.section}`;
      const idCompare = `price-compare-${this.dataset.section}`;
      //console.log({currentPrice},{responseText});
      //console.log({id},{idCompare});
      const html = new DOMParser().parseFromString(responseText, 'text/html')
      const destination = document.getElementById(id);
      const destinationCompare = document.getElementById(idCompare);
      const source = html.getElementById(id);
      const sourceCompare = html.getElementById(idCompare);

      //console.log({destination},{destinationCompare},{source},{sourceCompare},{currentPrice},{comparePrice});
      if (source && destination) destination.innerHTML = source.innerHTML;
      const price = document.getElementById(`price-${this.dataset.section}`);
      const priceCompare = document.getElementById(`price-compare-${this.dataset.section}`);

      if (price) price.innerHTML = currentPrice;
      if (priceCompare && comparePriceRaw > priceRaw) priceCompare.innerHTML = comparePrice;
      console.log("this.currentVariant is ", this.currentVariant);
      let buttonMessage = this.currentVariant.end_of_life ? "Unavailable" : "Sold Out";
      let endOfLifeDisable = this.currentVariant.end_of_life;
      this.toggleAddButton(!this.currentVariant.available, buttonMessage,undefined,endOfLifeDisable);
  }

  renderCartStock(variantID, responseText) {
      const id = `lineItemShippingNote-${this.dataset.section}`;
      const html = new DOMParser().parseFromString(responseText, 'text/html')
      const destination = document.getElementById(id);
      const source = html.getElementById(id);

      if (source && destination) destination.innerHTML = source.innerHTML;

      const stock = document.getElementById(`lineItemShippingNote-${this.dataset.section}`);
      const shippingArrayElement = document.getElementById("variantShippingContainer");
      if (shippingArrayElement) {
        const shippingArray = shippingArrayElement.innerHTML;
        const variantsMetafields = JSON.parse(shippingArray);
  
  
        if (stock) {
          variantsMetafields.forEach(function (variantMetafield) {
            var cleanedUpVariantMetafieldVariant_id = variantMetafield.variant_id.replace(/[^\d]/g, '');
              if (cleanedUpVariantMetafieldVariant_id == variantID) {
                  stock.value = variantMetafield.metafield_value;
              }
          });
        }
      }
  }

  renderStock(variantID, responseText) {
      const id = `stock-${this.dataset.section}`;
      const html = new DOMParser().parseFromString(responseText, 'text/html')
      const destination = document.getElementById(id);
      const source = html.getElementById(id);

      if (source && destination) destination.innerHTML = source.innerHTML;

      const stock = document.getElementById(`stock-${this.dataset.section}`);
      const productForm = document.getElementById(`product-form-${this.dataset.section}`);

      const variantShippingContainerElement = document.getElementById("variantShippingContainer");

      if (variantShippingContainerElement ) {
        const variantShippingContainer = variantShippingContainerElement.innerHTML
        const variantsMetafields = JSON.parse(variantShippingContainer);
  
        const shippingInput = productForm.querySelector('input[name="properties[Shipping]"]');
        const shippingNote = stock.querySelector('#shippingNoteTime');
  
  
        if (stock) {
            variantsMetafields.forEach(function (variantMetafield) {
                if (variantMetafield.variant_id == variantID) {
                    if (shippingNote) {
                        shippingNote.innerHTML = variantMetafield.metafield_value;
                    }
  
                    if (shippingInput) {
                        shippingInput.value = variantMetafield.metafield.value;
                        shippingInput.dispatchEvent(new Event('change', {bubbles: true}));
                    }
                }
            });
        }
      }

  }

  renderProductImages(variantID, responseText) {
      const variantClass = `.v-${variantID}`;
      const galleryId = `gallery-${this.dataset.section}`;
      const destination = document.getElementById(galleryId);

      const html = new DOMParser().parseFromString(responseText, 'text/html')
      const source = html.getElementById(galleryId);

      if (source && destination) destination.innerHTML = source.innerHTML;

      const gallery = document.getElementById(`gallery-${this.dataset.section}`);

      if (gallery) {
          const variantDataPosition = gallery.querySelector(variantClass);

          if (variantDataPosition) {
              const position = Number(variantDataPosition.getAttribute('data-position'));
              const allImages = gallery.querySelectorAll(".product-image");
              allImages.forEach((image, index) => {
                  image.removeAttribute('style')
                  const positionIndex = Number(image.getAttribute('data-position'));
                  if (positionIndex < position) image.style.display = 'none';
                  if (positionIndex > position + 3) image.style.display = 'none';

              })

          }
      }

      const gallerySlider = document.getElementById(`gallery-${this.dataset.section}`);

      if (gallerySlider) {
          const gallerySliderDataPosition = gallerySlider.querySelector(variantClass)
          if (gallerySliderDataPosition) {
              const position = Number(gallerySliderDataPosition.getAttribute('data-position'));
              this.splide.go(position - 1);
          }
      }
  }

  setUnavailable() {
      const button = document.getElementById(`product-form-${this.dataset.section}`);
      const addButton = button.querySelector('[name="add"]');
      const addButtonText = button.querySelector('[name="add"] > span');
      const price = document.getElementById(`price-${this.dataset.section}`);
      if (!addButton) return;
      addButtonText.textContent = window.variantStrings.unavailable;
      if (price) price.classList.add('visibility-hidden');
  }

  getVariantData() {
    const endOfLifeText = document.getElementById('endOfLife').textContent;
    const endOfLifeData = JSON.parse(endOfLifeText);
      this.variantData = this.variantData || JSON.parse(this.querySelector('[type="application/json"]').textContent);
      this.variantData.forEach(variant => {
        const matchingEndOfLifeEntry = endOfLifeData.find(eol => eol.id === variant.id);
        variant.end_of_life = matchingEndOfLifeEntry ? matchingEndOfLifeEntry.end_of_life : null;
    });
      return this.variantData;
  }

  async renderBillboard(variantId) {
      const metafields = JSON.parse(this.querySelector('#ProductMetafields[type="application/json"]').textContent);
      const currentVariantMetafields = metafields[variantId];

      function animateImages(nodes, callback) {
          console.log(nodes)
          gsap.fromTo(nodes,
              {
                  autoAlpha: 0,
                  scale: 1.2,
                  transformOrigin: '50% 50%'
              },
              {
                  autoAlpha: 1,
                  scale: 1,
                  duration: 0.6,
                  ease: "(0.40, 0.00, 0.00, 1.00)",
                  rotation: 0.01,
                  onComplete: callback,
              },
          )
      }


      function loadImage(url) {
          return new Promise(resolve => {
              const image = new Image();
              image.setAttribute("class", "opacity-0")
              image.addEventListener('load', () => resolve(image));
              image.src = url;
          });
      }


      if (currentVariantMetafields) {
          const billboardWrapper = document.getElementById(`Billboard-${this.dataset.section}-Wrapper`);

          const leftImgPromise = loadImage(currentVariantMetafields.left);
          const rightImagePromise = loadImage(currentVariantMetafields.right);

          function removeElement(element) {
              return function() {
                  element.parentNode.removeChild(element);
              };
          }

          Promise.all([leftImgPromise, rightImagePromise]).then(images => {
              billboardWrapper.querySelector('.product-hero-banner__left').appendChild(images[0])
              billboardWrapper.querySelector('.product-hero-banner__right').appendChild(images[1])


              animateImages(images,
                  () => {
                      const oldLeftImg = billboardWrapper.querySelector('.product-hero-banner__left > img');
                      const oldRightImg = billboardWrapper.querySelector('.product-hero-banner__right > img');
                      gsap.delayedCall(1, removeElement(oldLeftImg))
                      gsap.delayedCall(1, removeElement(oldRightImg))
                  })
          })
      }
  }

  /*
updateMedia() {
    if (!this.currentVariant) return;
    if (!this.currentVariant.featured_media) return;

    const mediaGallery = document.getElementById(`MediaGallery-${this.dataset.section}`);
    mediaGallery.setActiveMedia(`${this.dataset.section}-${this.currentVariant.featured_media.id}`, true);

    const modalContent = document.querySelector(`#ProductModal-${this.dataset.section} .product-media-modal__content`);
    const newMediaModal = modalContent.querySelector(`[data-media-id="${this.currentVariant.featured_media.id}"]`);
    modalContent.prepend(newMediaModal);
}

updateShareUrl() {
    const shareButton = document.getElementById(`Share-${this.dataset.section}`);
    if (!shareButton) return;
    shareButton.updateUrl(`${window.shopUrl}${this.dataset.url}?variant=${this.currentVariant.id}`);
}
*/

}

customElements.define('variant-selects', VariantSelects);

class VariantRadios extends VariantSelects {
  constructor() {
      super();
  }

  updateOptions() {
      const fieldsets = Array.from(this.querySelectorAll('fieldset'));
      console.log({fieldsets});
      this.options = fieldsets.map((fieldset) => {
          return Array.from(fieldset.querySelectorAll('input')).find((radio) => radio.checked).value;
      });
  }
}

customElements.define('variant-radios', VariantRadios);

document.addEventListener('DOMContentLoaded', function() {
var variantSelector = document.querySelector('variant-radios');

// Check if a variant is specified in the URL
var urlParams = new URLSearchParams(window.location.search);
var variantIdFromUrl = urlParams.get('variant');

if (variantSelector) {
    if (variantIdFromUrl) {
        // Convert the ID from string to number
        variantIdFromUrl = parseInt(variantIdFromUrl);

        // Find and set the current variant based on the URL parameter
        variantSelector.currentVariant = variantSelector.getVariantData().find(v => v.id === variantIdFromUrl);

        // Manually call onVariantUpdate to update the page
        variantSelector.onVariantUpdate();
    } else {
        // Handle the case when no variant is specified in the URL
        // ... existing logic for handling no URL variant ...
    }
}
});